import { faCheck } from "@fortawesome/pro-regular-svg-icons/faCheck";
import { faTimes } from "@fortawesome/pro-regular-svg-icons/faTimes";
import { faTrash } from '@fortawesome/pro-solid-svg-icons/faTrash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Checkbox, Chip, Collapse, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, FormGroup, Grid, InputLabel, MenuItem, Radio, Select, SelectChangeEvent, Switch, TextField, Typography } from '@mui/material';
import { withStyles, WithStyles } from "@mui/styles";
import * as api from "api/Core";
import styles from "assets/jss/cardCreation.styles";
import { AppMessageBox } from 'components/AppMessageBox';
import ButtonBack from 'components/Buttons/ButtonBack';
import IconButtonAdd from 'components/Buttons/IconButtonAdd';
import IconButtonClose from 'components/Buttons/IconButtonClose';
import IconButtonCog from 'components/Buttons/IconButtonCog';
import IconButtonCollapsable from 'components/Buttons/IconButtonCollapsable';
import IconButtonDelete from 'components/Buttons/IconButtonDelete';
import { RequestIndicator } from 'components/CallServer';
import RequestErrorDialog from 'components/CallServer/RequestErrorDialog';
import { RequestErrorReport } from 'components/CallServer/RequestErrorReport';
import { ConvertUploadToFileThumbnaildGetDto, UploadingStatus } from 'components/FileUpload/AttachSelection';
import ImageZoom from 'components/ImageZoom';
import MuiRegularButton from 'components/MuiExtras/Button/MuiRegularButton';
import MuiBox from 'components/MuiExtras/MuiBox';
import MuiClickable from 'components/MuiExtras/MuiClickable';
import MuiConfirmation from 'components/MuiExtras/MuiConfirmation';
import MuiContainer from 'components/MuiExtras/MuiContainer';
import MuiKeyboardDatePicker from 'components/MuiExtras/MuiKeyboardDatePicker';
import MuiColor from 'components/MuiExtras/Typography/MuiColor';
import MuiDanger from 'components/MuiExtras/Typography/MuiDanger';
import MuiMuted from 'components/MuiExtras/Typography/MuiMuted';
import MuiReverse from 'components/MuiExtras/Typography/MuiReverse';
import MuiWarning from 'components/MuiExtras/Typography/MuiWarning';
import { withSnackbar, WithSnackbar } from 'components/SnackbarProvider/Snackbar';
import { TextPluralization } from 'components/TextPluralization';
import { AsyncUploader } from 'lib/AsyncUploader';
import LibUtils from 'lib/LibUtils';
import MediaUtils from 'lib/MediaUtils';
import { forEach } from 'lodash';
import { KnowledgeTestDifficultyLevel, KnowledgeTestImportance, KnowledgeTestSelectionMode, PublicationEditPermissions, PublicationType, SystemRoles } from 'models/ApiEnums';
import { AsyncUploadModel, FileThumbnaildGetDto, GetKwownledgeTestDto, KnowledgeTestAlternativeGetDto, KnowledgeTestAlternativeSaveDto, PublicationSuggestionDto, SaveKnowledgeTestDto, TopicSuggestionDto } from 'models/ApiModels';
import { AttachType, RequestLifeCycle } from 'models/AppModels';
import moment from "moment";
import * as React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import { KnowledgeTestImportanceName, KnowledgeTestLevelName } from "views/Dashboards/components/KnowledgeCommons";
import HandleAttach from 'views/KnowledgeTest/Components/HandleAttach';
import PublicationSelectionDrawer from 'views/Publication/Dialogs/PublicationSelectionDrawer';
import QuizVideo from 'views/Quiz/Components/QuizVideo';
import TopicAutoComplete from 'views/Topic/Components/TopicAutoComplete';


///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

class KnwlTestManager {
    constructor(data: KnowledgeTestAlternativeGetDto[]) {
        if (data) this.alternatives = data;
        else {
            this.alternatives = [];
            this.addAlternative("", true);
            this.addAlternative("", false);
        }
    }

    alternatives: KnowledgeTestAlternativeGetDto[];

    addAlternative = (text: string, shouldBeSelected: boolean) => {
        this.alternatives.push({ id: LibUtils.newGuid(), text, feedback: "", feedback2: "", shouldBeSelected: shouldBeSelected, recommendations: [], useDefaultFeedback: !shouldBeSelected });
    };

    changeCorrectAnswer = (id: string, mode: KnowledgeTestSelectionMode, checked: boolean) => {
        this.alternatives.forEach((v) => {
            if (v.id == id) {
                v.shouldBeSelected = checked;
                if (checked) v.useDefaultFeedback = false;
            }
            else if (mode == KnowledgeTestSelectionMode.Simple) v.shouldBeSelected = false;
        });
    };

    changeSelectionMode = (mode: KnowledgeTestSelectionMode) => {
        if (mode == KnowledgeTestSelectionMode.Simple) {
            var firstCorrect = this.alternatives.find(p => p.shouldBeSelected);
            if (firstCorrect != null) {
                this.alternatives.forEach((v) => {
                    if (v.id != firstCorrect.id) v.shouldBeSelected = false;
                });
            }
        }
    };

    get saveDto(): KnowledgeTestAlternativeSaveDto[] {
        return this.alternatives.map(
            (v) => {
                return {
                    id: v.id,
                    feedback: v.feedback,
                    feedback2: v.feedback2,
                    shouldBeSelected: v.shouldBeSelected,
                    text: v.text,
                    recommendations: v.recommendations.map((x) => x.key),
                    useDefaultFeedback: v.useDefaultFeedback
                } as KnowledgeTestAlternativeSaveDto;
            });
    }

    get isValid() {
        return this.alternatives.every(v => v.text.length > 0);
    }
}

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

interface IProps {
    testId?: string;

    initialTopic?: TopicSuggestionDto;
    initialDifficultyLevel?: KnowledgeTestDifficultyLevel;

    onClose: (result: boolean) => void;
}

interface IValidation {
    title?: boolean;
    topics?: boolean;
    alternatives?: boolean;
    period?: boolean;
}

interface IState {
    record: Partial<GetKwownledgeTestDto>;
    manager: KnwlTestManager;
    validation: IValidation;

    selectedAttach: AttachType;
    uploadingStatus: UploadingStatus;

    continueOnSave: boolean;
    expandPeriod: boolean;
    step: number;
    altEditIndex: number;
    dialog: any;

    formCycle: RequestLifeCycle;
    lastError: any;
}

type Props = IProps & WithTranslation & WithSnackbar & WithStyles<typeof styles>;

const MaxAlternatives = 7;
const MaxRecommendations = 5;

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

class CreateTest extends React.Component<Props, IState> {

    private testsCreated = 0;
    private readonly = false;
    private feedbackRef: any = null;

    ///
    constructor(props: Props) {
        super(props);
        this.state = this.getInitialState(false);
    }

    ///
    private res(r: string, f: any = null) {
        return this.props.t("Views.KnowledgeTest.CreateTest." + r, f);
    }

    ///
    private updateRecord(data: Partial<GetKwownledgeTestDto>) {
        return { ...this.state.record, ...data };
    }

    ///
    private getInitialState(continueOnSave: boolean): IState {
        return {
            record: {
                testId: null,
                title: "",
                answerSelectionMode: KnowledgeTestSelectionMode.Simple,
                difficultyLevel: this.props.initialDifficultyLevel || KnowledgeTestDifficultyLevel.Beginner,
                importance: KnowledgeTestImportance.Normal,
                applyTestEndDate: null,
                applyTestStartDate: null,
                alternatives: null,
                topics: this.props.initialTopic ? [this.props.initialTopic] : [],
                editPermissions: PublicationEditPermissions.Full,
                hasAnswers: false,
                active: true,
                defaultFeedback: null,
                defaultRecommendations: []
            },
            validation: {
                title: null,
                topics: this.props.initialTopic ? true : false,
                alternatives: null,
                period: true
            },

            manager: new KnwlTestManager(null),
            selectedAttach: null,
            uploadingStatus: "none",

            step: 1,
            expandPeriod: false,
            altEditIndex: null,
            continueOnSave: continueOnSave,
            dialog: null,

            formCycle: RequestLifeCycle.None,
            lastError: null
        };
    }

    ///
    private getContinueState(): IState {

        var s = this.state.record;

        return {
            record: {
                testId: null,
                title: "",
                answerSelectionMode: s.answerSelectionMode,
                difficultyLevel: s.difficultyLevel,
                importance: s.importance,
                applyTestEndDate: s.applyTestEndDate,
                applyTestStartDate: s.applyTestStartDate,
                alternatives: null,
                topics: s.topics,
                editPermissions: s.editPermissions,
                hasAnswers: false,
                active: true,
                defaultRecommendations: [],
                defaultFeedback: null,
                attach: null,
            },
            validation: {
                title: null,
                topics: s.topics ? true : false,
                alternatives: null,
                period: true
            },

            manager: new KnwlTestManager(null),
            selectedAttach: null,
            uploadingStatus: "none",

            step: 1,
            expandPeriod: this.state.expandPeriod,
            altEditIndex: null,
            continueOnSave: this.state.continueOnSave,
            dialog: null,

            formCycle: RequestLifeCycle.None,
            lastError: null
        };
    }

    ///
    private load(testId: string) {
        this.setState({ formCycle: RequestLifeCycle.Loading });
        api.getKnowledgeTest(testId)
            .then((record) => {

                // Fixa tópico novamente, somente para inclusão
                if (this.props.initialTopic != null && testId == null) {
                    var t = record.topics.find(p => p.key == this.props.initialTopic.key);
                    t.fixed = true;
                    t.canDelete = false;
                }

                this.readonly = record.hasAnswers || record.editPermissions != PublicationEditPermissions.Full;

                this.setState({
                    formCycle: RequestLifeCycle.None,

                    step: record.editPermissions == PublicationEditPermissions.None ? 0 : 1,
                    record,
                    manager: new KnwlTestManager(record.alternatives),
                    selectedAttach: record.attach == null || record.attach.mainFile == null
                        ? null
                        : record.attach.mainFile.mimeType.indexOf("video") > -1
                            ? AttachType.Video
                            : AttachType.Image,
                    uploadingStatus: "none",
                    expandPeriod: record.applyTestStartDate != null || record.applyTestEndDate != null,
                    validation: {
                        topics: true,
                        title: true,
                        alternatives: true,
                        period: true,
                    }
                });
            })
            .catch((error) => {
                this.setState({ lastError: error, formCycle: RequestLifeCycle.LoadFailed });
            });
    }

    ///
    private canSave(): boolean {
        const { validation, manager } = this.state;
        return validation.title && validation.topics && validation.period && manager.isValid;
    }

    ///
    private save() {
        const { record, manager } = this.state;

        const dto: SaveKnowledgeTestDto = {
            testId: record.testId,
            title: record.title,
            answerSelectionMode: record.answerSelectionMode,
            difficultyLevel: record.difficultyLevel,
            importance: record.importance,

            applyTestEndDate: record.applyTestEndDate,
            applyTestStartDate: record.applyTestStartDate,

            alternatives: manager.saveDto,

            topics: record.topics.map((v) => { return v.key; }),

            attach: record.attach == null ? null : {
                fileId: record.attach.mainFile.fileId,
                thumbnailId: record.attach.thumbnail == null ? null : record.attach.thumbnail.fileId
            },

            defaultFeedback: record.defaultFeedback,
            defaultRecommendations: record?.defaultRecommendations?.map(v => v.key)
        };

        this.setState({ formCycle: RequestLifeCycle.Posting });

        api.saveKnowledgeTest(dto)
            .then((result) => {

                this.testsCreated++;

                this.props.snackbar.showMessage(this.res("SaveSuccess"), "success");

                if (this.state.continueOnSave) {
                    this.setState(this.getContinueState());
                }
                else {
                    this.props.onClose(this.testsCreated > 0);
                }
            })
            .catch((error) => {
                this.setState({ lastError: error, formCycle: RequestLifeCycle.PostFailed });
            });
    }

    ///
    private goStep1() {
        if (!this.hasDefaultFeedback()) {
            var alternatives = this.state.record.alternatives;
            forEach(alternatives, (a) => {
                if (!a.shouldBeSelected && a.useDefaultFeedback) a.useDefaultFeedback = false;
            });
        }

        this.setState({ step: 1 });
    }

    ///
    private goStep2() {
        this.setState(({ step, record, validation }) => {
            validation.title = record.title.length > 0;
            validation.alternatives = this.state.manager.isValid;
            if (validation.title && validation.alternatives) step++;
            return { step, validation };
        });
    }

    ///
    private goStep3(index: number) {
        this.setState({ step: 3, altEditIndex: index });
    }

    ///
    private goStep4() {
        if (this.state.record.attach != null) {
            this.setState({ step: 4 });
        }
    }

    ///
    private goStep5() {
        this.setState({ step: 5 });
    }

    ///
    private handleFileUploaded(e: AsyncUploadModel) {

        var data: FileThumbnaildGetDto = ConvertUploadToFileThumbnaildGetDto(e);
        var at = MediaUtils.getAttachTypeFromMimeType(data.mainFile.mimeType);

        if (at == AttachType.Image) {
            this.setState({
                selectedAttach: AttachType.Image,
                record: this.updateRecord({ attach: data })
            });
        }
        else if (at == AttachType.Video)
            this.setState({
                selectedAttach: AttachType.Video,
                record: this.updateRecord({ attach: data })
            });
    }

    ///
    private handleUploadingStatus = (status: UploadingStatus) => {
        this.setState({ uploadingStatus: status });
    };

    ///
    private removeAttach(fileOrContent: FileThumbnaildGetDto) {

        const asyncUploader: AsyncUploader = new AsyncUploader({});

        this.setState({
            dialog: (
                <MuiConfirmation
                    message={this.props.t("Components.AttachSelection.ConfirmDelete")}
                    onClose={
                        (result) => {

                            this.setState(
                                { dialog: null },
                                () => {

                                    if (result) {

                                        const attach = fileOrContent as FileThumbnaildGetDto;

                                        var files = [attach.mainFile.fileId];
                                        if (attach.thumbnail != null) files.push(attach.thumbnail.fileId);

                                        asyncUploader.delete(files)
                                            .then(() => {
                                                this.setState({
                                                    record: this.updateRecord({ attach: null }),
                                                    selectedAttach: null,
                                                    step: 1
                                                });
                                            });
                                    }
                                }
                            );
                        }
                    }
                />
            )
        });
    }

    ///
    private handleAddAlternative = () => {
        const { manager } = this.state;

        if (manager.alternatives.length < MaxAlternatives) {
            manager.addAlternative("", false);
            this.setState({ manager }, () => {
                const el = document.getElementById(manager.alternatives[manager.alternatives.length - 1].id);
                if (el) el.focus();
            });
        }
    };

    ///
    private handleDeleteAlternative(index: number) {
        const { manager } = this.state;
        if (manager.alternatives.length > 2) {
            manager.alternatives.splice(index, 1);
            this.setState({ manager });
        }
    }

    ///
    private handleAlternativePublicationSuggestion = () => {
        const { manager, altEditIndex } = this.state;
        const alternative = manager.alternatives[altEditIndex];

        this.setState({
            dialog: (
                <PublicationSelectionDrawer
                    excludeOptions={
                        {
                            excludePublicationsType: [
                                PublicationType.List,
                                PublicationType.Survey,
                                PublicationType.Poll,
                                PublicationType.Question,
                                PublicationType.Answer,
                                PublicationType.Course
                            ]
                        }
                    }
                    onSelect={
                        (result) => {
                            if (result != null) {

                                const suggestion: PublicationSuggestionDto = {
                                    key: result.publication.publicationId,
                                    label: result.publication.title,
                                    thumbnailUrl: result.publication.firstImageDataOrUrl,
                                    publicationType: result.publication.publicationType,
                                };

                                alternative.recommendations.push(suggestion);
                            }

                            return false;
                        }
                    }

                    onClose={() => this.setState({ dialog: null })}
                />
            )
        });
    };

    ///
    private handleTestPublicationSuggestion = () => {
        const { record } = this.state;

        this.setState({
            dialog: (
                <PublicationSelectionDrawer
                    excludeOptions={
                        {
                            excludePublicationsType: [
                                PublicationType.List,
                                PublicationType.Survey,
                                PublicationType.Poll,
                                PublicationType.Question,
                                PublicationType.Answer,
                                PublicationType.Course
                            ]
                        }
                    }
                    onSelect={
                        (result) => {
                            if (result != null) {

                                const suggestion: PublicationSuggestionDto = {
                                    key: result.publication.publicationId,
                                    label: result.publication.title,
                                    thumbnailUrl: result.publication.firstImageDataOrUrl,
                                    publicationType: result.publication.publicationType,
                                };

                                record.defaultRecommendations.push(suggestion);
                            }

                            return false;
                        }
                    }

                    onClose={() => this.setState({ dialog: null })}
                />
            )
        });
    };

    ///
    private hasDefaultFeedback() {
        const { record } = this.state;
        return (record.defaultFeedback != null && record.defaultFeedback.length > 0) || record.defaultRecommendations?.length > 0;
    }

    ///
    private step0() {
        return (
            <>
                <DialogContent className={this.props.classes.dialogContent}>
                    <AppMessageBox resource="PublicationEditPermissionDenied" />
                </DialogContent>
                <DialogActions />
            </>
        );
    }

    ///
    private step1() {
        const { classes } = this.props;
        const { manager, record, selectedAttach, validation } = this.state;
        const autoFocusIndex = record.title == "" ? -1 : manager.alternatives.findIndex(p => p.text.length == 0);

        return (
            <>
                <DialogContent className={classes.dialogContent}>

                    <div className={classes.container}>

                        <MuiContainer>

                            <TextField
                                autoFocus
                                fullWidth
                                multiline
                                margin="normal"
                                label={this.res("TitleLabel")}
                                autoComplete="off"
                                placeholder={this.res("TitlePlaceholder")}
                                error={validation.title === false}
                                value={record.title}
                                onChange={
                                    (e) => {
                                        const newValue = e.target.value;
                                        this.setState(state => {
                                            state.record.title = newValue;
                                            state.validation.title = newValue.length > 0;
                                            return state;
                                        });
                                    }
                                }
                                inputProps={
                                    {
                                        maxLength: 512
                                    }
                                }
                            />

                            <HandleAttach
                                acceptedTypes={[AttachType.Image, AttachType.Video]}
                                selectedType={selectedAttach}
                                readonly={this.readonly}
                                onClick={() => this.goStep4()}
                                onUploadComplete={(e) => this.handleFileUploaded(e)}
                                onUploadStatusChange={this.handleUploadingStatus}
                            />

                        </MuiContainer>

                        <div className={classes.highlightBox}>

                            <Grid container justifyContent="center" alignItems="center">
                                <Grid item xs>
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                checked={record.answerSelectionMode == KnowledgeTestSelectionMode.Multi}
                                                color="secondary"
                                                disabled={this.readonly}
                                                onChange={
                                                    (e, checked) => {
                                                        var newType = checked ? KnowledgeTestSelectionMode.Multi : KnowledgeTestSelectionMode.Simple;
                                                        manager.changeSelectionMode(newType);
                                                        this.setState(state => {
                                                            state.record.answerSelectionMode = newType;
                                                            return state;
                                                        });
                                                    }
                                                }
                                            />
                                        }
                                        label={this.res("MultiChooseLabel")}
                                        labelPlacement="end"
                                    />
                                </Grid>
                                <Grid item>
                                    <IconButtonCog
                                        size="small"
                                        color={record.defaultFeedback?.length > 0 || record.defaultRecommendations?.length > 0 ? "warning" : null}
                                        onClick={() => this.goStep5()}
                                    />
                                </Grid>
                            </Grid>

                            <MuiContainer>
                                {
                                    manager.alternatives.map((v, index) => {
                                        return (
                                            <Grid container alignContent="center" alignItems="flex-start" spacing={1}>
                                                <Grid item>
                                                    {
                                                        record.answerSelectionMode == KnowledgeTestSelectionMode.Simple
                                                            ? <Radio
                                                                value={v.id}
                                                                checked={v.shouldBeSelected}
                                                                disabled={this.readonly}

                                                                onChange={
                                                                    (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
                                                                        manager.changeCorrectAnswer(v.id, record.answerSelectionMode, checked);
                                                                        this.setState({ manager });
                                                                    }
                                                                }
                                                            />
                                                            : <Checkbox
                                                                value={v.id}
                                                                checked={v.shouldBeSelected}
                                                                disabled={this.readonly}
                                                                onChange={
                                                                    (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
                                                                        manager.changeCorrectAnswer(v.id, record.answerSelectionMode, checked);
                                                                        this.setState({ manager });
                                                                    }
                                                                }
                                                            />
                                                    }
                                                </Grid>
                                                <Grid xs item>
                                                    <TextField
                                                        id={v.id}
                                                        fullWidth
                                                        autoFocus={index == autoFocusIndex}
                                                        placeholder={this.res("AlternativePlaceholder")}
                                                        error={validation.alternatives === false && manager.alternatives[index].text.length == 0}
                                                        value={manager.alternatives[index].text}
                                                        onChange={
                                                            (e) => {
                                                                manager.alternatives[index].text = e.currentTarget.value;
                                                                this.setState({ manager });
                                                            }
                                                        }
                                                        inputProps={
                                                            {
                                                                maxLength: 512
                                                            }
                                                        }
                                                        onKeyDown={
                                                            (e) => {
                                                                if (e.keyCode == 13) {
                                                                    if (index < manager.alternatives.length - 1) {
                                                                        const el = document.getElementById(manager.alternatives[index + 1].id);
                                                                        if (el) el.focus();
                                                                    }
                                                                    else if (manager.alternatives[index].text.length > 0 && manager.alternatives.length < 5) {
                                                                        this.handleAddAlternative();
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    />

                                                    <div>
                                                        <MuiMuted>
                                                            {
                                                                v.recommendations.length > 0 &&
                                                                <>
                                                                    <TextPluralization count={v.recommendations.length} resource="Views.KnowledgeTest.CreateTest.RecommendationText" />
                                                                    {v.feedback && v.feedback.length > 0 && <span> &ndash; </span>}
                                                                </>
                                                            }

                                                            {
                                                                record.answerSelectionMode == KnowledgeTestSelectionMode.Simple && v.feedback && v.feedback.length > 0 &&
                                                                <span>&quot;{v.feedback}&quot;</span>
                                                            }

                                                            {
                                                                record.answerSelectionMode == KnowledgeTestSelectionMode.Multi &&
                                                                <>
                                                                    {
                                                                        v.feedback && v.feedback.length > 0 &&
                                                                        <div><MuiColor variant="error"><FontAwesomeIcon icon={faTimes} fixedWidth />&quot;{v.feedback}&quot;</MuiColor></div>
                                                                    }
                                                                    {
                                                                        v.feedback2 && v.feedback2.length > 0 &&
                                                                        <div><MuiColor variant="success"><FontAwesomeIcon icon={faCheck} fixedWidth />&quot;{v.feedback2}&quot;</MuiColor></div>
                                                                    }
                                                                </>
                                                            }
                                                        </MuiMuted>
                                                    </div>
                                                </Grid>

                                                {
                                                    manager.alternatives.length > 2 && !this.readonly &&
                                                    <Grid item>
                                                        <IconButtonDelete size="small" onClick={() => this.handleDeleteAlternative(index)} />
                                                    </Grid>
                                                }

                                                {
                                                    v.text.length > 0 &&
                                                    <Grid item>
                                                        <IconButtonCog size="small" onClick={() => this.goStep3(index)} />
                                                    </Grid>
                                                }
                                            </Grid>
                                        );
                                    })
                                }
                            </MuiContainer>

                            <MuiContainer>
                                {
                                    manager.alternatives.length < MaxAlternatives && !this.readonly &&
                                    <p>
                                        <MuiRegularButton
                                            link
                                            color="warning"
                                            onClick={this.handleAddAlternative}
                                        >
                                            <span>+ {this.res("ButtonAddAlternativeText")}</span>
                                        </MuiRegularButton>
                                    </p>
                                }
                            </MuiContainer>

                        </div>

                    </div>
                </DialogContent>
                <DialogActions>

                    <div className={classes.footerMessage}>
                        <b>{this.res("Footer1")}</b>
                        <span>&nbsp;&raquo;&nbsp;</span>
                        <span>{this.props.t("Views.Publication.Common.Form.Footer2")}</span>
                    </div>
                    <MuiRegularButton
                        width="small"
                        variant="contained"
                        color="primary"
                        onClick={() => this.goStep2()}
                    >
                        {this.props.t("Common.Buttons.ContinueText")}
                    </MuiRegularButton>
                </DialogActions>
            </>
        );
    }

    ///
    private step2() {
        const { classes } = this.props;
        const { record, validation, continueOnSave, expandPeriod } = this.state;
        const { editPermissions } = record;
        let { applyTestEndDate, applyTestStartDate } = record;

        return (
            <>
                <DialogContent>
                    <div className={classes.container}>

                        <TopicAutoComplete
                            autoFocus
                            overModal
                            label={this.res("TopicLabel")}
                            skipTopicAccessCheckFor={SystemRoles.TrainingManager}
                            selectedItems={record.topics}
                            margin="normal"
                            error={validation.topics == false}
                            onChange={
                                (topics) => {
                                    this.setState(state => {
                                        state.record.topics = topics;
                                        state.validation.topics = state.record.topics.length > 0;
                                        return state;
                                    });
                                }
                            }
                        />


                        <Grid container alignItems="center" spacing={2}>
                            <Grid item xs>

                                <FormControl fullWidth margin="normal">
                                    <InputLabel htmlFor="difficultyLevel">{this.res("DifficultyLabel")}</InputLabel>

                                    <Select
                                        fullWidth
                                        value={record.difficultyLevel}
                                        onChange={
                                            (e: SelectChangeEvent<KnowledgeTestDifficultyLevel>) => {
                                                this.setState(state => {
                                                    record.difficultyLevel = e.target.value as KnowledgeTestDifficultyLevel;
                                                    return state;
                                                });
                                            }
                                        }
                                        inputProps={{
                                            id: 'difficultyLevel',
                                        }}
                                    >
                                        <MenuItem value={KnowledgeTestDifficultyLevel.Beginner}><KnowledgeTestLevelName value={KnowledgeTestDifficultyLevel.Beginner} /></MenuItem>
                                        <MenuItem value={KnowledgeTestDifficultyLevel.Intermediate}><KnowledgeTestLevelName value={KnowledgeTestDifficultyLevel.Intermediate} /></MenuItem>
                                        <MenuItem value={KnowledgeTestDifficultyLevel.Advanced}><KnowledgeTestLevelName value={KnowledgeTestDifficultyLevel.Advanced} /></MenuItem>
                                    </Select>
                                </FormControl>

                            </Grid>

                            <Grid item xs>

                                <FormControl fullWidth margin="normal">
                                    <InputLabel htmlFor="importance">{this.res("ImportanceLabel")}</InputLabel>
                                    <Select
                                        fullWidth
                                        value={record.importance}
                                        onChange={
                                            (e: SelectChangeEvent<KnowledgeTestImportance>) => {
                                                this.setState({
                                                    record: this.updateRecord({ importance: e.target.value as KnowledgeTestImportance }),
                                                });

                                            }
                                        }
                                        inputProps={{
                                            id: 'importance',
                                        }}
                                    >
                                        <MenuItem value={KnowledgeTestImportance.Low}><KnowledgeTestImportanceName value={KnowledgeTestImportance.Low} /></MenuItem>
                                        <MenuItem value={KnowledgeTestImportance.Normal}><KnowledgeTestImportanceName value={KnowledgeTestImportance.Normal} /></MenuItem>
                                        <MenuItem value={KnowledgeTestImportance.High}><KnowledgeTestImportanceName value={KnowledgeTestImportance.High} /></MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                        </Grid>
                        <br />
                        <div>
                            <MuiClickable
                                onClick={
                                    () => {
                                        this.setState({ expandPeriod: !expandPeriod });
                                    }
                                }
                            >
                                <MuiReverse color="muted">
                                    <IconButtonCollapsable
                                        size="small"
                                        expanded={expandPeriod}
                                    />
                                    <span>{this.res("WhenApplyTitle")}</span>
                                </MuiReverse>
                            </MuiClickable>

                            <Collapse in={expandPeriod} timeout="auto" unmountOnExit>
                                <Grid container justifyContent="space-between" alignItems="flex-end">
                                    <Grid item>
                                        <MuiKeyboardDatePicker
                                            fullWidth
                                            clearable
                                            disabled={editPermissions != PublicationEditPermissions.Full}
                                            label={this.res("ApplyStartDateLabel")}
                                            placeholder={this.props.t("Common.Literals.DateUnlimited")}
                                            minDate={moment('1900-01-01')}
                                            value={applyTestStartDate}
                                            error={validation.period == false}
                                            InputLabelProps={
                                                {
                                                    shrink: true
                                                }
                                            }
                                            onChange={
                                                (date, v) => {
                                                    this.setState(state => {
                                                        if (date == null)
                                                            applyTestStartDate = null;
                                                        else {
                                                            applyTestStartDate = date.toDate();
                                                            applyTestStartDate.setHours(0);
                                                            applyTestStartDate.setMinutes(0);
                                                            applyTestStartDate.setSeconds(0);
                                                        }
                                                        state.record.applyTestStartDate = applyTestStartDate;
                                                        return state;
                                                    });
                                                }
                                            }
                                            onBlur={
                                                () => {
                                                    this.setState(state => {
                                                        state.validation.period = (state.record.applyTestStartDate == null || state.record.applyTestEndDate == null || state.record.applyTestStartDate >= state.record.applyTestEndDate);
                                                        return state;
                                                    });
                                                }
                                            }
                                        />
                                    </Grid>

                                    <Grid item>
                                        <MuiKeyboardDatePicker
                                            fullWidth
                                            clearable
                                            disabled={editPermissions != PublicationEditPermissions.Full}
                                            label={this.res("ApplyEndDateLabel")}
                                            placeholder={this.props.t("Common.Literals.DateUnlimited")}
                                            minDate={moment('1900-01-01')}
                                            error={validation.period == false}
                                            value={applyTestEndDate}
                                            InputLabelProps={
                                                {
                                                    shrink: true
                                                }
                                            }
                                            onChange={
                                                (date, v) => {
                                                    this.setState(state => {
                                                        if (date == null)
                                                            applyTestEndDate = null;
                                                        else {
                                                            applyTestEndDate = date.toDate();
                                                            applyTestEndDate.setHours(23);
                                                            applyTestEndDate.setMinutes(59);
                                                            applyTestEndDate.setSeconds(59);
                                                        }
                                                        state.record.applyTestEndDate = applyTestEndDate;
                                                        return state;
                                                    });
                                                }}
                                            onBlur={
                                                () => {
                                                    this.setState(state => {
                                                        state.validation.period = (state.record.applyTestStartDate == null || state.record.applyTestEndDate == null || state.record.applyTestStartDate >= state.record.applyTestEndDate);
                                                        return state;
                                                    });
                                                }
                                            }
                                        />
                                    </Grid>

                                </Grid>
                            </Collapse>
                        </div>
                    </div>

                </DialogContent>

                <DialogActions>
                    <Grid container justifyContent="space-between" alignItems="center">
                        <Grid item>
                            {
                                this.props.testId == null
                                    ? (

                                        <FormControlLabel
                                            label={this.res("ContinueOnSaveLabel")}
                                            labelPlacement="end"
                                            control={
                                                <Checkbox
                                                    checked={continueOnSave}
                                                    onChange={
                                                        (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
                                                            this.setState({ continueOnSave: checked });
                                                        }
                                                    }
                                                />
                                            }
                                        />
                                    )
                                    : <span>&nbsp;</span>
                            }
                        </Grid>

                        <Grid item>

                            <MuiRegularButton
                                width="small"
                                onClick={() => this.goStep1()}
                            >
                                <span>{this.props.t("Views.Publication.Common.Form.ButtonBackText")}</span>
                            </MuiRegularButton>

                            <MuiRegularButton
                                width="small"
                                color="success"
                                onClick={() => this.save()}
                                disabled={!this.canSave()}
                            >
                                <span>{this.props.t("Views.Publication.Common.Form.ButtonFinishText")}</span>
                            </MuiRegularButton>

                        </Grid>
                    </Grid>
                </DialogActions>
            </>
        );
    }

    ///
    private step3() {
        const { classes } = this.props;
        const { record, manager, altEditIndex } = this.state;
        const alternative = manager.alternatives[altEditIndex];
        const hasDefaultFeedback = this.hasDefaultFeedback();
        const applyDefaultFeedback = hasDefaultFeedback && !alternative.shouldBeSelected && alternative.useDefaultFeedback;
        const feedback = applyDefaultFeedback ? record.defaultFeedback : alternative.feedback;
        const recommendations = applyDefaultFeedback ? record.defaultRecommendations : alternative.recommendations;

        const chips =
            recommendations.map(item => (
                <Chip
                    key={item.key}
                    tabIndex={-1}
                    label={item.label}
                    size="small"
                    className={classes.autocompleteChip}
                    classes={
                        {
                            label: classes.autocompleteLimitedWidth,
                            labelSmall: classes.autocompleteLimitedWidth
                        }
                    }
                    onDelete={
                        alternative.useDefaultFeedback
                            ? null
                            : () => {
                                const index = alternative.recommendations.indexOf(item);
                                alternative.recommendations.splice(index, 1);
                                this.setState({ manager });
                            }
                    }
                />
            ));

        return (
            <DialogContent>
                <MuiContainer margin="normal">
                    <MuiBox variant="mutedLight" padding="1x" >
                        <Grid container spacing={3} wrap="nowrap" alignItems="center">
                            <Grid item>
                                <Typography variant="h6">{this.res("AlternativeOptionsTitle")}</Typography>
                                <small>{alternative.text}</small>
                            </Grid>
                        </Grid>
                    </MuiBox>
                </MuiContainer>

                <div className={classes.container}>
                    {
                        hasDefaultFeedback && !alternative.shouldBeSelected &&
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={alternative.useDefaultFeedback}
                                    color="secondary"
                                    onChange={
                                        (e, checked) => {
                                            alternative.useDefaultFeedback = checked;
                                            if (!checked) {

                                                if (alternative.feedback == null || alternative.feedback.length == 0)
                                                    alternative.feedback = record.defaultFeedback;

                                                if (alternative.recommendations == null || alternative.recommendations.length == 0)
                                                    alternative.recommendations = record.defaultRecommendations.slice();
                                            }
                                            this.setState({ manager }, () => { if (!checked) this.feedbackRef.focus(); });
                                        }
                                    }
                                />
                            }
                            label={this.res("FeedbackDefaultLabel")}
                            labelPlacement="end"
                        />
                    }

                    <FormGroup>
                        <TextField
                            autoFocus
                            fullWidth
                            multiline
                            maxRows={3}
                            disabled={applyDefaultFeedback}
                            margin="normal"
                            label={record.answerSelectionMode == KnowledgeTestSelectionMode.Multi ? this.res("FeedbackMultiIncorrectLabel") : this.res("FeedbackLabel")}
                            value={feedback}
                            inputRef={(ref) => this.feedbackRef = ref}
                            inputProps={
                                {
                                    maxLength: 512,
                                }
                            }
                            onChange={
                                (e) => {
                                    alternative.feedback = e.currentTarget.value;
                                    this.setState({ manager });
                                }
                            }
                        />
                    </FormGroup>

                    {
                        record.answerSelectionMode == KnowledgeTestSelectionMode.Multi &&
                        <FormGroup>
                            <TextField
                                fullWidth
                                multiline
                                maxRows={3}
                                margin="normal"
                                label={this.res("FeedbackMultiCorrectLabel")}
                                value={alternative.feedback2}
                                inputProps={
                                    {
                                        maxLength: 512,
                                    }
                                }
                                onChange={
                                    (e) => {
                                        alternative.feedback2 = e.currentTarget.value;
                                        this.setState({ manager });
                                    }
                                }
                            />
                        </FormGroup>
                    }

                    <FormGroup>
                        <TextField
                            fullWidth
                            margin="normal"
                            label={this.res("RecommendLabel", { count: MaxRecommendations })}
                            disabled={applyDefaultFeedback}
                            InputProps={
                                {
                                    classes: {
                                        root: classes.autocompleteInputRoot
                                    },
                                    startAdornment: chips,
                                    readOnly: true,
                                    endAdornment: alternative.recommendations.length < MaxRecommendations && !alternative.useDefaultFeedback
                                        ? <IconButtonAdd size="small" onClick={this.handleAlternativePublicationSuggestion} />
                                        : null
                                }
                            }
                        />
                    </FormGroup>

                </div>
                <DialogActions>
                    <ButtonBack variant="contained" onClick={() => this.goStep1()} />
                </DialogActions>
            </DialogContent>
        );
    }


    ///
    private step5() {
        const { classes } = this.props;
        const { record } = this.state;

        const chips =
            record.defaultRecommendations?.map(item => (
                <Chip
                    key={item.key}
                    tabIndex={-1}
                    label={item.label}
                    size="small"
                    className={classes.autocompleteChip}
                    classes={
                        {
                            label: classes.autocompleteLimitedWidth,
                            labelSmall: classes.autocompleteLimitedWidth
                        }
                    }
                    onDelete={
                        () => {
                            const index = record.defaultRecommendations.indexOf(item);
                            record.defaultRecommendations.splice(index, 1);
                            this.setState({ record });
                        }
                    }
                />
            ));

        return (
            <DialogContent>
                <MuiBox variant="mutedLight" padding="1x" >
                    <Grid container spacing={3} wrap="nowrap" alignItems="center">
                        <Grid item>
                            <Typography variant="h6">{this.res("TestOptionsTitle1")} <MuiDanger>{this.res("TestOptionsTitle2")}</MuiDanger> </Typography>
                            <small><b>{this.res("TestOptionsSubTitle")}</b></small>
                        </Grid>
                    </Grid>
                </MuiBox>

                <div className={classes.container}>

                    <FormGroup>
                        <TextField
                            autoFocus
                            fullWidth
                            margin="normal"
                            label={this.res("FeedbackLabel")}
                            value={record.defaultFeedback}
                            inputProps={
                                {
                                    maxLength: 512,
                                }
                            }
                            onChange={
                                (e) => {
                                    record.defaultFeedback = e.currentTarget.value;
                                    this.setState({ record });
                                }
                            }
                        />
                    </FormGroup>

                    <FormGroup>
                        <TextField
                            fullWidth
                            margin="normal"
                            label={this.res("RecommendLabel", { count: MaxRecommendations })}
                            InputProps={
                                {
                                    classes: {
                                        root: classes.autocompleteInputRoot
                                    },
                                    startAdornment: chips,
                                    readOnly: true,
                                    endAdornment: record.defaultRecommendations?.length < MaxRecommendations
                                        ? <IconButtonAdd size="small" onClick={this.handleTestPublicationSuggestion} />
                                        : null
                                }
                            }
                        />
                    </FormGroup>

                </div>
                <DialogActions>
                    <ButtonBack variant="contained" onClick={() => this.goStep1()} />
                </DialogActions>
            </DialogContent>
        );
    }

    ///
    private step4() {
        const { classes } = this.props;
        const { record, selectedAttach } = this.state;

        var message = this.res(
            selectedAttach == AttachType.Video
                ? "LinkedVideoText"
                : "LinkedImageText"
        );

        return (
            <DialogContent>

                <MuiContainer margin="dense">
                    <MuiBox variant="mutedLight" padding="1x">
                        <Grid container spacing={3} wrap="nowrap" justifyContent="space-between" alignItems="center">
                            <Grid item xs>
                                <Typography variant="h6">{message}</Typography>
                            </Grid>
                            {
                                !this.readonly &&
                                <Grid item>
                                    <MuiRegularButton
                                        simple
                                        color="error"
                                        onClick={() => { this.removeAttach(record.attach); }}
                                    >
                                        <FontAwesomeIcon icon={faTrash} fixedWidth />
                                    </MuiRegularButton>
                                </Grid>
                            }
                        </Grid>
                    </MuiBox>
                </MuiContainer>

                <div className={classes.container} style={{ justifyContent: "center", alignItems: "center" }}>
                    <div>
                        {
                            selectedAttach == AttachType.Video
                                ? <QuizVideo fileOrEmbedVideo={record.attach.mainFile} />
                                : <ImageZoom thumbnail={record.attach.thumbnail} image={record.attach.mainFile} />
                        }
                    </div>
                </div>
                <DialogActions>
                    <ButtonBack variant="contained" onClick={() => this.goStep1()} />
                </DialogActions>
            </DialogContent >
        );
    }

    ///
    public componentDidMount() {
        if (this.props.testId != null) {
            this.load(this.props.testId);
        }
    }

    ///
    public render() {
        const { formCycle, lastError, step, record: { hasAnswers } } = this.state;

        return (
            <Dialog
                open={true}
                maxWidth={"md"}
            >
                <DialogTitle>
                    <Grid container justifyContent="space-between">
                        <Grid item>
                            <Typography variant="h6" component="p">
                                {
                                    this.res(
                                        this.state.record.testId ? "TitleEdit" : "TitleNew"
                                    )
                                }
                            </Typography>
                            {
                                hasAnswers &&
                                <Typography variant="body2">
                                    <MuiWarning><small>{this.res("HasAnswersMessage")}</small></MuiWarning>
                                </Typography>
                            }
                        </Grid>
                        <Grid item>
                            <IconButtonClose
                                color="inherit"
                                size="small"
                                onClick={() => this.props.onClose(this.testsCreated > 0)}
                            />
                        </Grid>
                    </Grid>
                </DialogTitle>

                {
                    formCycle == RequestLifeCycle.LoadFailed
                        ? (
                            <DialogContent className={this.props.classes.dialogContent}>
                                <RequestErrorReport error={lastError} />;
                            </DialogContent>
                        )
                        : step == 0
                            ? this.step0()
                            : step == 1
                                ? this.step1()
                                : step == 2
                                    ? this.step2()
                                    : step == 3
                                        ? this.step3()
                                        : step == 4
                                            ? this.step4()
                                            : step == 5
                                                ? this.step5()
                                                : null
                }

                {formCycle == RequestLifeCycle.Loading && <RequestIndicator type="request" />}
                {formCycle == RequestLifeCycle.Posting && <RequestIndicator type="post" />}

                <RequestErrorDialog
                    open={formCycle == RequestLifeCycle.PostFailed}
                    error={this.state.lastError}
                    onClose={() => this.setState({ lastError: null, formCycle: RequestLifeCycle.None })}
                />

                {this.state.dialog}

            </Dialog>
        );
    }
}

export default withSnackbar(withTranslation()(withStyles(styles)(CreateTest)));